// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";

// Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyD6JDz_q8ipcrmxugbIpYwv5zOv1gf4Q-Y",
  authDomain: "mhome-9d65b.firebaseapp.com",
  projectId: "mhome-9d65b",
  storageBucket: "mhome-9d65b.appspot.com", // fixed typo: use ".appspot.com"
  messagingSenderId: "873542159026",
  appId: "1:873542159026:web:6e5f79ba8932566dad17ab",
  measurementId: "G-XFHSHELJKH"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Services
export const db = getFirestore(app);       // Firestore
export const storage = getStorage(app);    // Storage (optional now, still available)
export const auth = getAuth(app);          // Auth

// 🔐 Set persistent login (so user stays logged in on reload)
setPersistence(auth, browserLocalPersistence);
